var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'style-ese': _vm.style === 'ese', 'style-plune': _vm.style === 'plune'},attrs:{"id":"app"}},[_c('Header'),_c('transition',{attrs:{"mode":"out-in","name":"wipe","appear":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }